<template>
  <v-dialog v-model="show" width="80%">
    <v-card>
      <v-card-title>
        <span class="headline">DoNo</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="confirm" class="ml-2 mr-2">確定</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex>
              <v-text-field label="doNo" v-model="doNo"></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field label="blNo" v-model="blNo"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    doNo: '',
    blNo: '',
    show: false
  }),
  methods: {
    popup() {
      this.show = true
    },
    confirm() {
      this.$emit('popData', { doNo: this.doNo, blNo: this.blNo })
      this.doNo = ''
      this.blNo = ''
      this.show = false
    }
  }
}
</script>
